const GRID_XLRG = 1400;
const GRID_LRG = 1239;
const GRID_MED = 899;
const GRID_SML = 749;

export const SLIDER_BREAKPOINTS = [
    {
        breakpoint: GRID_XLRG,
        slides: 5,
    },
    {
        breakpoint: GRID_LRG,
        slides: 4,
    },
    {
        breakpoint: GRID_MED,
        slides: 3,
    },
    {
        breakpoint: GRID_SML,
        slides: 2,
    },
];
